import { respondTo } from "@/respondTo";
import Image from "next/image";
import { Box } from "@mui/material";
import { styled } from "@mui/material";

export const BlogPostHeaderImageContainer = styled("div")(
  ({ theme }) =>
    `
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
  height: 100px;
  border-radius: 24px;

  ${respondTo.mobile_landscape`
        height: 13.3125rem; 
    `}

  &.list {
    ${respondTo.tablet_portrait`
            height: 12.3125rem; 
        `}

    ${respondTo.tablet_landscape`        
        height: 15rem; 
        `}

        ${respondTo.desktop`        
            height: 17rem; 
        `}
  }

  &.related {
    ${respondTo.tablet_portrait`
            width: 22.375rem;
            height: 13.3125rem; 
        `}

    ${respondTo.tablet_landscape`        
        width: 25rem;
        height: 15rem; 
        `}

        ${respondTo.desktop`        
            width: 27.75rem;
            height: 16.9375rem;
        `}
  }
`
);
export const BlogPostImageContainer = styled("div")(
  ({ theme }) => `
  overflow: hidden;
  min-width: 100px;
  min-height: 100px;
  position: relative;
  border-radius: 24px;
  border: 1px solid ${theme.palette.common.corporateColors.primary.white};

  &.list {
    ${respondTo.tablet_portrait`
            height: 12.3125rem; 
        `}

    ${respondTo.tablet_landscape`        
            height: 15rem; 
        `}

        ${respondTo.desktop`        
            height: 17rem; 
        `}
  }

  &.related {
    ${respondTo.tablet_portrait`
            width: 22.375rem;
            height: 13.3125rem; 
        `}

    ${respondTo.tablet_landscape`        
            width: 25rem;
            height: 15rem; 
        `}

        ${respondTo.desktop`        
            width: 27.75rem;
            height: 16.9375rem;
        `}
  }
`
);

export const BlogPostAuthorImageContainer = styled(Image)(
  ({ theme }) => `
    border-radius: 50%;
  border: 1px solid 
    ${theme.palette.common.corporateColors.secondary.turquoise};
  width: 32px !important; // Ensures the Next.js Image respects this
  height: 32px !important; // Ensures the Next.js Image respects this
  object-fit: cover;
  overflow: hidden;
`
);

export const BlogPost = styled(Box)(
  ({ theme }) =>
    `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.25rem;
    align-self: stretch;
    padding: 1.5rem;
    border : 1px solid ${theme.palette.common.corporateColors.primary.white};
    border-radius: 1.5rem;
    cursor: pointer;
    transition: background 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    :hover {
        background: linear-gradient(
  0deg,
  rgba(82, 212, 204, 0.20) 0%,
  rgba(82, 212, 204, 0.20) 100%
), 
#031F32;

    }      
`
);

export const BlogPostBody = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`;

export const BlogPostFooter = styled("div")`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
`;
